import React from 'react'
import { Form, Modal } from 'react-bootstrap'
import Button from '../command/Button/Button';
import { useTranslation } from 'react-i18next';

interface optOutModalProps {
  show: boolean;
  optOutHide: () => void;
}

const OptOutModal: React.FC<optOutModalProps> = ({ optOutHide, ...props }) => {

  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      aria-labelledby="user-profile-modal"
      centered
      // size="lg"
      onHide={optOutHide}
      className='otp-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title id="otp-modal">
          {t('marketing-preferences')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='user-profile-wrapper'>
          <Form.Check
            type={'checkbox'}
            checked
            id={`renticy-update`}
            className='terms-checkbox mb-0'
            label={
              <>{t('optout-modal-description')}</>
            }
          />
        </div>
      </Modal.Body>
      <Modal.Footer className='mt-2'>
        <Button btnText={t('continue')} />
      </Modal.Footer>
    </Modal>
  )
}

export default OptOutModal